import { I18nType } from '@/ui/types/i18n.types';
import { ObjectLike } from '@/types/objectlike.types';

export default function (vm: any): I18nType {
  return {
    getText(componentName: string, submodule: string, property: string) {
      return vm.$i18n.t(`${componentName}.${submodule}.${property}`);
    },
    getFormattedText(
      componentName: string,
      submodule: string,
      property: string,
      variables: ObjectLike,
    ) {
      return vm.$i18n.t(`${componentName}.${submodule}.${property}`, variables);
    },
  };
}
